import { Route } from 'types/route.type';
import PurchaseHistory from './purchase-history';

export const routes: Route[] = [
  {
    path: '/order-feed/purchase-history/:siteErpId?/:globalSiteId?',
    component: PurchaseHistory,
    id: 'orderFeed.navigation.purchaseHistory',
  },
];
